<template>
  <o-view :has-white-background="true" :no-scroll="true">
    <o-view :bottom-padding="true">
      <o-nav-bar
        title="Cambio"
        :has-back-button="true"
        :has-close-button="true"
        :is-overlay="true"
      />
      <o-map :markers="markers" />
      <o-section-header title="Beheer reservatie" />
      <o-section>
        <o-alert :center="true">
          <p>Jouw wagennummer is</p>
          <p class="u-code">M1</p>
        </o-alert>
        <o-key-value label="Locatie" value="Gent" />
        <o-key-value label="Standplaats" value="Gent-Dampoort" />
        <o-key-value label="Wagenklasse" value="S Micro. autom. - 2 + 2 pl." />
        <o-key-value label="Vertrek" value="24/06/2019 - 11:00" />
        <o-key-value label="Aankomst" value="24/06/2019 - 17:00" />
        <o-key-value label="Verzekering" value="Volledige dekking" />
        <o-key-value label="Gewenste reikweidte" value="25 km" />
      </o-section>
    </o-view>
    <o-bottom-buttons>
      <template #buttons>
        <o-button
          label="Pas deze reservatie aan"
          to="/sales/car/cambio/reservations/edit"
          :is-secondary="true"
          :full="true"
        />
        <o-slider-button
          label-left="Sluiten"
          icon-left="lock"
          label-right="Openen"
          icon-right="unlocked"
          @clickleft="showOverlay('confirmClose')"
          @clickright="showOverlay('confirmOpen')"
        />
      </template>
      <template #note>
        <p>
          Schuif naar links om je wagen definitief af te sluiten. Doe de
          <router-link :to="{ name: 'providerscambiounlockedinstructions' }"
            >afsluit check</router-link
          >
          voor je dit doet. Schuif naar rechts voor het openen van de wagen.
        </p>
      </template>
    </o-bottom-buttons>
    <o-loading :visible="isOpening">
      <p>
        Je wagen wordt nu geopend. Indien dit niet gebeurt, vergewis je dan dat
        je naast de juiste wagen staat (Gent-Dampoort S1).
      </p>
    </o-loading>
    <o-overlay ref="confirmOpen">
      <p>
        Bevind je je nabij je gereserveerde wagen (Gent-Dampoort S1) met
        nummerplaat 1-ABC-123?
      </p>
      <o-button label="Bevestigen" @click="openCar" :is-primary="true" />
    </o-overlay>
    <o-loading :visible="isClosing">
      <p>
        Je wagen wordt nu gesloten.
      </p>
    </o-loading>
    <o-overlay ref="confirmClose">
      <p>
        Ben je zeker dat je je gereserveerde wagen (Gent-Dampoort S1) met
        nummerplaat 1-ABC-123 wil sluiten?
      </p>
      <o-button label="Bevestigen" @click="closeCar" :is-primary="true" />
    </o-overlay>
  </o-view>
</template>

<script>
import OMap from '@/components/OMap.vue'
import OPayButton from '@/components/OPayButton.vue'
import OOverlay from '@/components/base/OOverlay.vue'
import OLoading from '@/components/base/OLoading.vue'
import OSliderButton from '@/components/OSliderButton.vue'

export default {
  name: 'CambioCurrent',
  components: {
    OLoading,
    OOverlay,
    OMap,
    OPayButton,
    OSliderButton
  },
  data() {
    return {
      isOpening: false,
      isClosing: false,
      markers: [
        {
          coordinates: [3.715, 51.05],
          type: 'cambio',
          title: 'Cambio'
        }
      ]
    }
  },
  methods: {
    openCar() {
      this.hideOverlay('confirmOpen')
      this.isOpening = true
      setTimeout(() => {
        this.$router.push(
          '/sales/car/cambio/reservations/unlocked-confirmation'
        )
      }, 3000)
    },

    closeCar() {
      this.hideOverlay('confirmClose')
      this.isClosing = true
      setTimeout(() => {
        this.$router.push('/sales/car/cambio/reservations/locked-confirmation')
      }, 3000)
    }
  }
}
</script>
